@mixin footerButton($borderColor) {
  border: 1px solid #{$borderColor};
  border-radius: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  color: #F2F4F6;
}

.edit-name-modal{
  .modal-backdrop {
    display: flex !important;
    .modal-dialog {
      width: 500px;
      margin: auto;
      .modal-content {
        border: 2px solid #3C4756;
        border-radius: 7px;
        .modal-header {
          background: #262F39;
          color: #C1CAD6;
          text-align: center;
          padding-top: 0;
          padding-bottom: 0;
          border-bottom: 0;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          .modal-title {

          }
        }
        .modal-body {
          padding: 12% 10%;
          background: #1D232C;
          input{
            width:100%;
            background: transparent;
            color: white;
            text-align: center;
            padding: 10px;
            border: 1px solid;
          }
        }
        .modal-footer {
          border-top: 0;
          background: #262F39;
          color: whitesmoke;
          text-align: center;
          cursor: pointer;
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
          padding-top: 9px;
          padding-bottom: 9px;
          padding-left: 40px;
          padding-right: 40px;
          .btn-container {
            width: 100%;
            display: flex;
            .save {
              @include footerButton(#1E944F);
              width: 45%;
            }
            .seperator {
              width: 10%;
            }
            .btn-close {
              @include footerButton(#900035);
              width: 45%;
            }
          }
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/recipe/editor/edit-name-modal/edit-name-modal.scss